module.exports = __webpack_public_path__ + "img/4.4a753b70.jpg";